module.exports = __webpack_public_path__ + "static/media/team-2.3db7a9e9.png";